import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';
import partial from 'lodash/partial';
import idx from 'idx';
import { bindActionCreators } from 'redux';
import {
  toggleAddModal, toggleAddParticipants, create, updateGroupParticipants, changeAddModalStep
} from 'focus_groups/ducks/view_state';
import { withRouter } from 'react-router';
import Participants from 'focus_groups/components/participants';
import { getProjectIdFromUrl } from 'project/utils';
import { DEFAULT_REQUIRED_MESSAGE } from 'common/components/form_fields';

export const FOCUS_GROUP_PARTICIPANT_FORM = 'FOCUS_GROUP_PARTICIPANT_FORM';

export function validate(values) {
  const errors = {};

  if (!values.first_name) {
    errors.first_name = DEFAULT_REQUIRED_MESSAGE;
  }

  if (!values.last_name) {
    errors.last_name = DEFAULT_REQUIRED_MESSAGE;
  }

  if (!values.users || !values.users.length) {
    errors.users = { _error: 'You must have at least one user in the focus group' };
  }

  return errors;
}

export function mapStateToProps(state) {
  const { profile_data } = state.user;
  const { focusGroups } = state.project;
  const { isCreating, showAddParticipants, currentGroup, details } = focusGroups.viewState;
  const selector = formValueSelector(FOCUS_GROUP_PARTICIPANT_FORM);
  /* only the form values that will be used in the component */
  const currentValues = selector(
    state, 'weight_votes', 'invite_message', 'first_name', 'last_name'
  );
  /* only allow to change whether votes should be weighted if creating a new group or no
     participant has been invited yet */
  const canWeightVotes = (
    !showAddParticipants ||
    (idx(currentGroup, _ => _.participants) || []).length === 0
  );

  return {
    isCreating,
    currentValues,
    showAddParticipants,
    canWeightVotes,
    initialValues: {
      invite_message: idx(currentGroup, _ => _.purpose) || idx(details, _ => _.purpose),
      weight_votes: currentGroup? currentGroup.weight_votes : true,
      users: [],
      first_name: idx(profile_data, _ => _.first_name),
      last_name: idx(profile_data, _ => _.last_name),
    },
  };
}

export function mapDispatchToProps(dispatch, { params }) {
  const projectId = getProjectIdFromUrl(params);
  return bindActionCreators({
    toggleCreate: toggleAddModal,
    toggleUpdate: toggleAddParticipants,
    onCreate: partial(create, projectId),
    onBack: partial(changeAddModalStep, 2),
    onUpdate: updateGroupParticipants,
  }, dispatch);
}

const ParticipantsForm = reduxForm({
  form: FOCUS_GROUP_PARTICIPANT_FORM,
  validate,
})(Participants);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ParticipantsForm));



// WEBPACK FOOTER //
// ./focus_groups/containers/participants.js